import { useQueryClient } from '@tanstack/react-query';
import { useStorageKeys } from '../../storage';
import { AUTHENTICATION_QUERY_KEY } from '../constants';
import { JwtAuthentication } from '../domain';
import { Graphback } from '../../graphql';
import { useGrippContext } from '../../grippContext';

export const useAccessTokenReceived = () => {
  const queryClient = useQueryClient();
  const { secureStorageHandler, storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();

  const onAccessTokenReceived = async (
    accessToken: string,
    isLeave: boolean = false,
    isInitialize: boolean = false
  ) => {
    let newAccessToken = accessToken;
    if (isLeave) {
      newAccessToken =
        (await secureStorageHandler.getItem(storageKeys.oldAccessToken)) || '';
      await secureStorageHandler.setItem(
        storageKeys.accessToken,
        newAccessToken
      );
      await secureStorageHandler.deleteItem(storageKeys.oldAccessToken);
    } else {
      const current_accessToken = await secureStorageHandler.getItem(
        storageKeys.accessToken
      );
      if (current_accessToken && current_accessToken != newAccessToken) {
        await secureStorageHandler.setItem(
          storageKeys.oldAccessToken,
          current_accessToken
        );
      }
      await secureStorageHandler.setItem(
        storageKeys.accessToken,
        newAccessToken
      );
    }
    if (isInitialize) {
      await secureStorageHandler.deleteItem(storageKeys.oldAccessToken);
    }

    Graphback.dispose();
    Graphback.initialize(newAccessToken);

    queryClient.setQueryData(
      AUTHENTICATION_QUERY_KEY,
      new JwtAuthentication(newAccessToken),
      { updatedAt: Date.now() }
    );

    // clean up local storage
    await storageHandler.deleteItem(storageKeys.redirectPath);
    await storageHandler.deleteItem(storageKeys.redirectUrl);
    
    if (!isInitialize) {
      await storageHandler.deleteItem(storageKeys.workspace);
    }
  };

  return onAccessTokenReceived;
};
